/*
 * @Author: your name
 * @Date: 2021-01-04 16:47:47
 * @LastEditTime: 2021-01-10 13:59:28
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \vr-fornt-end\src\components\modeldemo\Tool\Json2Request.js
 */

import * as Utils from '../Utils'

export function SettingJsonToApiJson (setting) {
  const rls = {
    model: {
      modelPkId: setting.model_id,
      modelName: setting.model_name,
      modelDescription: setting.model_description,
      modelOwner: '',
      modelUrl: setting.model_url,
      coverRoot: setting.cover_root,
      textureRoot: setting.texture_root,

      isVoice: setting.is_voice,
      modelVoiceUrl: setting.model_voice_url,
      isPasswordVisit: setting.is_password_visit,
      modelVisitPassword: setting.model_visit_password,
      languageSelect: setting.language_select,
      modelShowType: setting.model_show_type,
      isPcBg: setting.is_pc_bg,
      pcBg: setting.pc_bg,
      isMobileBg: setting.is_mobile_bg,
      mobileBg: setting.mobile_bg,
      isShowModelLogo: setting.is_show_model_logo,
      modelLogo: setting.model_logo,
      isShowCoverText: setting.is_show_cover_text,
      modelCoverText: setting.model_cover_text,
      isStopLoadingPage: setting.is_stop_loading_page,
      modelIndexEnterType: setting.model_index_enter_type,

      isShowMaker: setting.is_show_maker,
      modelMaker: setting.model_maker,
      isShowAddress: setting.is_show_address,
      modelAddress: setting.model_address,
      isShowPhoneNumber: setting.is_show_phone_number,
      modelPhoneNumber: setting.model_phone_number,
      isShowTechnologySupport: setting.is_show_technology_support,
      modelTechnologySupport: setting.model_technology_support,
      isShowModelQrcode: setting.is_show_model_qrcode,
      modelQrcode: setting.model_qrcode,

      isSwitchBackgroundMusic: setting.is_switch_background_music,
      modelBackgroundMusic: setting.model_background_music,
      isSwitchOutlineMap: setting.is_switch_outline_map,
      isPlayOnHotpoint: setting.is_play_on_hotpoint,
      mapSelect: setting.map_select,
      isShowBarrage: setting.is_show_barrage,
      isShowPopularity: setting.is_show_popularity,
      isSwitchModelVr: setting.is_switch_model_vr,
      isSwitchGravity: setting.is_switch_gravity,
      isSwitchShareable: setting.is_switch_shareable,
      isSwitchReturnLink: setting.is_switch_return_link,
      modelReturnLink: setting.model_return_link,

      isMeasureEnable: setting.is_measureable,
      isSwitchBuildMark: setting.is_switch_build_mark,
      isCompass: setting.is_compass,
      modelCompassAngle: setting.model_compass_angle,

      isShowIcon: setting.model_points.is_show_icon,
      iconUrl: setting.model_points.icon_url,
      iconDisableTexture: '',
      onVisiableTexture: '',
      offVisiableTexture: '',

      isLimitAngle: setting.model_points.is_limit_angle,
      isAutoCurrect: setting.model_points.is_auto_currect,
      mgraph: setting.model_points.mgraph === null ? null : Utils.matrixToString(setting.model_points.mgraph),
      switchType: setting.model_views.switch_type,
      isAutoPlay: setting.model_views.is_auto_play,
      isQuickNavigation: setting.model_views.is_quick_navigation,
      isShowMark: setting.model_marks.is_show_mark,
      isShowIn3d: setting.model_hotpoints.is_show_in_3d,
      isFiveMeter: setting.model_hotpoints.is_five_meter,
      guideName: setting.model_hotpoints.guide_name,
      isRecommened: false,
      isPublish: false,
      isUploadLoading: false,
      loadingUrl: setting.loading_url | ''
    },
    pointPortalList: [],
    pointList: [],
    hotpointList: [],
    viewList: [],
    guideList: [],
    animationList: [],
    markerList: [],
    tagIconList: [],
    bulletList: [],
    bulletheaderList: []
  }

  // 进入点
  for (const p of setting.model_portal) {
    const item = {
      portalId: p.portal_id,
      portalName: p.portal_name,
      pointId: p.point_id,
      portalLonAngle: p.portal_angle[0],
      portalLatAngle: p.portal_angle[1],
      modelId: setting.model_id
    }
    rls.pointPortalList.push(item)
  }

  // 点位
  for (const p of setting.model_points.points) {
    const item = {
      pointId: p.point_id,
      pointIndex: p.point_id,
      pointType: p.point_type,
      pointFloor: p.point_floor,
      pointPosition: Utils.arrayToString(p.point_position),
      pointForward: Utils.arrayToString(p.point_forward),
      isCorrect: p.is_correct,
      pointCorrection: Utils.arrayToString(p.point_correction),
      isVisible: p.is_visible,
      modelId: setting.model_id
    }
    rls.pointList.push(item)
  }

  // 热点
  for (const hp of setting.model_hotpoints.hotpoints) {
    const item = {
      hotpointId: hp.hotpoint_id,
      hotpointType: hp.hotpoint_type,
      hotpointTitle: hp.hotpoint_title,
      hotpointIconUrl: hp.hotpoint_icon_url,
      hotpointPosition: Utils.arrayToString(hp.hotpoint_position),
      pointId: hp.point_id,
      coverFaceId: hp.cover_face_id,

      hotpointTitleType: '',
      isShowTitle: hp.hotpoint_title_style ? hp.hotpoint_title_style.is_show_title : undefined,
      fontSize: hp.hotpoint_title_style ? hp.hotpoint_title_style.font_size : undefined,
      switchAttenuation: hp.hotpoint_title_style ? hp.hotpoint_title_style.is_size_attenuation : undefined,
      fontColor: hp.hotpoint_title_style ? hp.hotpoint_title_style.font_color : undefined,
      backgroundColor: hp.hotpoint_title_style ? hp.hotpoint_title_style.background_color : undefined,

      hotpointImageUrls: hp.hotpoint_image_urls ? Utils.arrayToString(hp.hotpoint_image_urls) : undefined,

      hotpointTextMessage: '',
      textTitle: hp.hotpoint_text_message ? hp.hotpoint_text_message.text_title : undefined,
      textBody: hp.hotpoint_text_message ? hp.hotpoint_text_message.text_body : undefined,

      link: hp.link,
      jumpId: hp.jump_id,
      cornerPosition: Utils.arrayToString(hp.corner_position),
      normal: Utils.arrayToString(hp.normal),

      hotpointMediaUrl: hp.hotpoint_media_url,
      hotpointVoiceUrl: undefined,
      modelId: setting.model_id
    }
    rls.hotpointList.push(item)
  }

  // 场景
  let order = 0
  for (const v of setting.model_views.views) {
    const item = {
      viewId: v.view_id,
      viewName: v.name,
      viewCoverFaceId: v.view_cover_face_id,
      pointId: v.point_id,
      viewAngle: Utils.arrayToString(v.view_angle),
      viewOrderId: order++,
      modelId: setting.model_id
    }
    rls.viewList.push(item)
  }

  const pointLength = rls.pointList.length
  const imageLength = Utils.arrayToString(pointLength).length
  // 导航
  for (const g of setting.model_hotpoints.guide) {
    for (const hp of rls.hotpointList) {
      if (hp.hotpointId !== g) continue

      const item = {
        guideId: 'asdasd',
        guideHotpointId: g,
        guideName: hp.hotpointTitle,
        guideType: hp.hotpointType,
        guideCoverUrl: Utils.coverImagePath(rls.model.coverRoot, 'low', imageLength, (hp.pointId + 1), hp.coverFaceId) + '.jpg',
        modelId: setting.model_id
      }
      rls.guideList.push(item)
    }
  }

  // 动画
  for (const a of setting.model_hotpoints.animation) {
    const item = {
      animationId: 'asdasd',
      hotpointId: a,
      animationName: '',
      animationType: '',
      animationCoverUrl: '',
      modelId: setting.model_id
    }
    rls.animationList.push(item)
  }

  // 标签
  for (const mark of setting.model_marks.marks) {
    const item = {
      markerId: mark.mark_id,
      markerName: mark.mark_name,
      viewAngle: Utils.arrayToString(mark.view_angle),
      modelId: setting.model_id
    }
    rls.markerList.push(item)
  }

  /*
  // 弹幕
  for (const hp of setting.model_hotpoints.hotpoints) {
    const item = {

    }
    rls.bulletList.push(item)
  }

  // 弹幕头像
  for (const hp of setting.model_hotpoints.hotpoints) {
    const item = {
      m
    }
    rls.bulletheaderList.push(item)
  }
  */
  return rls
}
